<template>

  <b-container ref="login">
    <b-row :class="loginHeight" class=" mx-auto" align-h="center" align-v="center">
      <b-col>
        <b-row>
          <b-col>
            <h2>{{ $t('loginBtnSubmit') }}</h2>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col cols="9">
            <b-form-group
                id="fieldset-1"
                :label="$t('loginLabelEmail')"
                label-for="input-1"
                :invalid-feedback="invalidFeedbackEmail"
                :state="verifyEmail"
            >
              <b-form-input v-on:keyup.enter="verifyForm" id="input-1" v-model="email"
                            :state="verifyEmail" trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-row>
              <b-col cols="9">
                <b-form-group
                    id="fieldset-2"
                    :label="$t('loginLabelPassword')"
                    label-for="input-2"
                    :invalid-feedback="invalidFeedbackPassword"
                    :state="verifyPassword"
                >
                  <b-form-input v-on:keyup.enter="verifyForm" :type="showPassword ? 'text' : 'password'" id="input-2"
                                v-model="password"
                                :state="verifyPassword" trim></b-form-input>

                </b-form-group>
              </b-col>
              <b-col align-self="center">
                <b-icon-eye-fill v-on:click="showPassword = false" v-if="showPassword" scale="1.5"></b-icon-eye-fill>
                <b-icon-eye-slash-fill scale="1.5" v-else v-on:click="showPassword = true"></b-icon-eye-slash-fill>
              </b-col>
            </b-row>

            <button v-on:click="verifyForm" type="button" class="btn colorBtn form-control-sm">
              {{ $t('loginBtnSubmit') }}
            </button>
          </b-col>
        </b-row>
        <b-row class="mt-3" align-h="end">
          <b-col>
            <router-link to="/register" v-if="!admin" class="login" style="cursor: pointer;">
              {{ $t('loginLabelRegister') }}
            </router-link>
          </b-col>
          <b-col cols="5">
            <a v-if="!admin" v-on:click="resetPassword" class="login"
               style="cursor: pointer">{{ $t('loginLabelResetPassword') }}</a>
          </b-col>
        </b-row>
        <b-col class="mt-3">
          <p v-if="$i18n.locale=='cat'">Si t'has inscrit i no et deixa entrar correctament, assegura que t'has desconnectat d'altres dispositius i/o navegadors abans de tornar-ho a intentar. Si no pots entrar, escriu-nos a info@timeuse.barcelona </p>
          <p v-if="$i18n.locale==='en'"> If you have registered and you cannot enter correctly, make sure you have logged out from other devices and/or browsers before trying again. If you cannot enter, write us at info@timeuse.barcelona</p>
        </b-col>
      </b-col>
      <b-modal id="modal-center" centered
               :title="$t('loginModalTitleResetPassword')">
        <b-row class="mt-4">
          <b-col>
            <p>{{ $t('loginModalInfo') }}</p>
            <b-form-group
                id="fieldset-resetPassword"
                :label="$t('loginLabelEmail')"
                label-for="input-ResetPassword"
                :invalid-feedback="invalidFeedbackResetPasswordEmail"
                :state="verifyResetPasswordEmail"
            >
              <b-form-input v-on:keyup.enter="sendEmail" v-bind:placeholder="$t('loginPlaceHolderEmail')"
                            id="input-ResetPassword" v-model="resetPasswordEmail"
                            :state="verifyResetPasswordEmail"
                            trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <template #modal-footer>
          <b-button variant="danger" v-on:click="hideModal"
          >
            {{ $t('adminModalBtnClose') }}
          </b-button>
          <b-button
              v-on:click="sendEmail"
          >
            {{ $t('loginModalButtonSend') }}
          </b-button>
        </template>
      </b-modal>
    </b-row>
  </b-container>
</template>

<script>
import app from "../firebaseConfig/config";
import apiService from "../service/service";
import Cryptr from 'crypto-js'

export default {
  name: "Login",
  data() {
    return {
      admin: false,
      email: '',
      password: '',
      verifyEmail: null,
      verifyPassword: null,
      invalidFeedbackEmail: '',
      invalidFeedbackPassword: '',
      name: null,
      code: '',
      loginHeight: 'loginHeight',
      resetPasswordEmail: '',
      invalidFeedbackResetPasswordEmail: '',
      verifyResetPasswordEmail: null,
      showPassword: false
    }
  },
  methods: {
    /**
     * Verify form that all data is correct for save to server
     */
    verifyForm() {
      this.verifyEmail = this.email.includes('@') ? null : false
      this.invalidFeedbackEmail = this.email.includes('@') ? '' : this.$i18n.t('errorMessageInvalidMailFormat').toString()
      this.verifyPassword = this.invalidFeedbackPassword = this.password.length > 6 ? null : false
      this.invalidFeedbackPassword = this.password.length > 6 ? '' : this.$i18n.t('errorMessageLengthPassword').toString()
      if (!this.verifyEmail && !this.verifyPassword) this.verifyCredentials()
    },
    /**
     * Verify if user credentials in firebase auth
     * @returns {Promise<void>}
     */
    async verifyCredentials() {
      try {
        this.$store.commit('updateIsLoading', true)
        let user
        try {
          user = await app.auth().signInWithEmailAndPassword(this.email, this.password)

        } catch (e) {
          user = await app.auth().signInAnonymously()
        }
        if (user) {
          try {
            await this.verifyUserCredentials()
          } catch (e) {
            console.log(e)
            this.$store.commit('updateIsLoading', false)
            this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
              title: 'Error',
              variant: 'danger',
              solid: true
            })
            this.invalidFeedbackPassword = this.$i18n.t('errorMessageCudNotConnectServer').toString()
            this.invalidFeedbackEmail = this.$i18n.t('errorMessageCudNotConnectServer').toString()
          }
        }

      } catch (e) {
        console.log(e)
        this.$store.commit('updateIsLoading', false)
        this.verifyPassword = false;
        this.verifyEmail = false;
        if (e.message === 'The password is invalid or the user does not have a password.') {
          this.invalidFeedbackPassword = this.$i18n.t('errorMessageUsernamePassword').toString()
          this.invalidFeedbackEmail = this.$i18n.t('errorMessageUsernamePassword').toString()
          this.$bvToast.toast(this.$i18n.t('errorMessageUsernamePassword').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        } else if (e.message === 'The email address is badly formatted.') {
          this.verifyPassword = null
          this.invalidFeedbackEmail = this.$i18n.t('errorMessageInvalidMailFormat').toString()
          this.$bvToast.toast(this.$i18n.t('errorMessageInvalidMailFormat').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })
        } else {
          this.invalidFeedbackPassword = this.$i18n.t('errorMessageCudNotConnectServer').toString()
          this.invalidFeedbackEmail = this.$i18n.t('errorMessageCudNotConnectServer').toString()
          this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })

        }
      }
    },
    /**
     * Function that verify user's role passed in param and delete or set cookies
     * If there's no errors go to player page or admin page
     * @param response
     */
    setCookies(response) {
      response.data.user.role === 'admin' ? this.admin = true : this.admin = false
      this.$store.commit('updateRole', response.data.user.role)
      this.setCookie('userRole', response.data.user.role, true)
      if (this.name === null && response.data !== true) {
        this.name = `${response.data.user.name} ${response.data.user.surname}`
        this.email = response.data.user.email
      }
      this.setCookie('name', this.name, false)
      this.setCookie('email', this.email, false)
      this.setCookie('userCompany', response.data.user.userCompany, false)
      if (!this.admin) this.$emit('verifyEvent')//this.$router.push({path: `/player/${this.code}1`})
      if (this.admin) this.$router.push({path: `/home`})
    },
    /**
     * Verify of user exist in firestore
     * @returns {Promise<void>}
     */
    async verifyUserCredentials() {
      const newUser = {
        email: this.email,
        password: this.password,
        company: "Barcelona Time Use",
        isUserWithPassword: true
      }
      try {
        const acesToken = await app.auth().currentUser.getIdToken(true)
        const response = await apiService.verifyCredentials(newUser, acesToken)
        this.setCookies(response)
      } catch (e) {
        if (!e.response.data) {
          this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })

        } else {
          switch (e.response.data.error) {
            case 'Company not exist':
              this.$bvToast.toast(this.$i18n.t('errorMessageUserNotExist').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
            case 'Invalid password':
              this.$bvToast.toast(this.$i18n.t('errorMessageUsernamePassword').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
            case 'User does not exist':
              this.$bvToast.toast(this.$i18n.t('errorMessageUserNotExist').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
            default:
              this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
          }
        }
        this.$store.commit('updateIsLoading', false)
        this.invalidFeedbackPassword = this.$i18n.t('errorMessageCudNotConnectServer').toString()
        this.invalidFeedbackEmail = this.$i18n.t('errorMessageCudNotConnectServer').toString()
      }
    },
    /**
     * Get value of cookie passed by param
     * @param cname
     * @returns {string}
     */
    getCookie(cname) {
      const name = cname + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    /**
     * Set cookie of information passed by params
     * @param cookieName
     * @param cookieValue
     * @param encrypted
     */
    setCookie(cookieName, cookieValue, encrypted) {
      const now = new Date()
      const time = now.getTime()
      const expireTime = time + 1000 * 36000
      now.setTime(expireTime)
      encrypted ? document.cookie = cookieName + "=" + Cryptr.AES.encrypt(cookieValue, 'secret key 1234').toString() + "; expires=" + now.toUTCString() : document.cookie = cookieName + "=" + cookieValue + "; expires=" + now.toUTCString()


    },
    /**
     * Verify Height of user widow for make Register more responsive
     */
    matchHeight() {
      const totalComponentsHeight = this.$refs.login.clientHeight + 87 + 100
      document.documentElement.clientHeight <= 930 ? this.loginHeight = 'min-vh-100' : this.loginHeight = 'loginHeight'
      if (totalComponentsHeight < document.documentElement.clientHeight) {
        if (this.footerClass !== 'footer') this.$store.commit('updateFooterClass', 'footer')

      } else {
        if (this.footerClass !== 'footerRelative') this.$store.commit('updateFooterClass', 'footerRelative')
      }
    },
    /**
     * Show Modal for reset user password
     */
    resetPassword() {
      this.$bvModal.show('modal-center')
    },
    /**
     * Hide Modal reset user password
     */
    hideModal() {
      this.$bvModal.hide('modal-center')
    },
    /**
     * Function for send email to user that does not remember her/his password
     * @returns {Promise<void>}
     */
    async sendEmail() {
      this.verifyResetPasswordEmail = this.resetPasswordEmail.includes('@') && this.resetPasswordEmail.includes('.') ? null : false
      this.invalidFeedbackResetPasswordEmail = this.resetPasswordEmail.includes('@') && this.resetPasswordEmail.includes('.') ? '' : this.$i18n.t('errorMessageInvalidMailFormat').toString()
      if (this.verifyResetPasswordEmail === null) {
        try {
          await apiService.resetPassword({email: this.resetPasswordEmail, company: 'Barcelona Time Use'})
          this.$bvToast.toast(this.$i18n.t('loginModalSendEmailSuccess').toString(), {
            variant: 'success',
            solid: true
          })
          this.hideModal()
        } catch (e) {
          this.verifyResetPasswordEmail = false
          switch (e.response.data.error) {
            case 'User does not exist':
              this.$bvToast.toast(this.$i18n.t('errorMessageUserNotExist').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
            default:
              this.$bvToast.toast(this.$i18n.t('errorMessageCudNotConnectServer').toString(), {
                title: 'Error',
                variant: 'danger',
                solid: true
              })
              break
          }
          /*this.invalidFeedbackResetPasswordEmail = this.$i18n.t('errorMessageInvalidMailFormat').toString()
          this.$bvToast.toast(this.$i18n.t('errorMessageInvalidMailFormat').toString(), {
            title: 'Error',
            variant: 'danger',
            solid: true
          })*/
        }

      }
    },
    /**
     * Delete cookie passed by param
     * @param name
     */
    deleteCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
  },
  mounted() {
    // const user = app.auth().currentUser
    // user? this.$router.push({path: `/player${this.code}/1`}) : null
    this.matchHeight()
    //Add event listener that detects when user refresh the window
    window.addEventListener("resize", this.matchHeight);
    this.deleteCookie('Token')
  },
  destroyed() {
    window.removeEventListener("resize", this.matchHeight);
  }
}
</script>

<style scoped>

.login {
  font-weight: bold;
  color: black;
}

.loginHeight {
  height: 80vh;
}

.colorBtn {
  background-color: #39bac1;
}
</style>
